import React, { useState, useEffect } from 'react';
import { addCategory, getSliderImages, deleteSliderImage, addSliderImage } from '../api/service';

function Sidebar({ categories, setCategories, setSelectedCategory }) {
  // State for category management (unchanged)
  const [showAddModal, setShowAddModal] = useState(false);
  const [kuName, setKuName] = useState('');
  const [arName, setArName] = useState('');
  const [enName, setEnName] = useState('');
  const [image, setImage] = useState(null);

  // State for slider image management
  const [showSliderModal, setShowSliderModal] = useState(false);
  const [sliderImages, setSliderImages] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  // Handler for adding a category (unchanged)
  const handleAddCategory = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('ku_name', kuName);
    formData.append('ar_name', arName);
    formData.append('en_name', enName);
    if (image) formData.append('image', image);

    try {
      const newCategory = await addCategory(formData);
      setCategories((prev) => [...prev, newCategory]);
      setSelectedCategory(newCategory);
      setShowAddModal(false);
      setKuName('');
      setArName('');
      setEnName('');
      setImage(null);
    } catch (error) {
      console.error('Failed to add category:', error);
    }
  };

  // Fetch slider images from the API
  const fetchSliderImages = async () => {
    setIsLoading(true);
    try {
      const data = await getSliderImages(); // Calls GET /slider
      setSliderImages(data); // Data is an array of sliders
      setError(null);
    } catch (err) {
      setError('Failed to fetch slider images');
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  // Fetch images when the slider modal opens
  useEffect(() => {
    if (showSliderModal) {
      fetchSliderImages();
    }
  }, [showSliderModal]);

  // Handler for deleting a slider image
  const handleDeleteSliderImage = async (imageId) => {
    setIsLoading(true);
    try {
      const updatedSliders = await deleteSliderImage(imageId); // Calls DELETE /slider/{id}
      setSliderImages(updatedSliders); // API returns updated list
      setError(null);
    } catch (err) {
      setError('Failed to delete slider image');
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  // Handler for adding a new slider image
  const handleAddSliderImage = async () => {
    if (!selectedFile) return;
    setIsLoading(true);
    const formData = new FormData();
    formData.append('image', selectedFile); // Matches the 'image' field expected by create method

    try {
      const updatedSliders = await addSliderImage(formData); // Calls POST /slider
      setSliderImages(updatedSliders); // API returns updated list
      setSelectedFile(null);
      setError(null);
    } catch (err) {
      setError('Failed to add slider image');
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="bg-dark text-white p-3" style={{ width: '250px', flexShrink: 0 }}>
      <h3 className="mb-4">Floranya</h3>
      <button className="btn btn-primary w-100 my-3" onClick={() => setShowAddModal(true)}>
        Add Category
      </button>
      <button className="btn btn-secondary w-100 my-3" onClick={() => setShowSliderModal(true)}>
        Manage Slider Images
      </button>
      <ul className="list-group">
        {categories.map((category) => (
          <li
            key={category.id}
            style={{"height" :40}}
            className="btn list-group-item list-group-item-action bg-dark text-white border-0"
            onClick={() => setSelectedCategory(category)}
          >
            {category.en_name}

          </li>
        ))}
      </ul>

      {/* Add Category Modal (unchanged) */}
      {showAddModal && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add Category</h5>
                <button type="button" className="btn-close" onClick={() => setShowAddModal(false)}></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleAddCategory}>
                  <div className="mb-3">
                    <input
                      type="text"
                      className="form-control"
                      value={kuName}
                      onChange={(e) => setKuName(e.target.value)}
                      placeholder="Kurdish Name"
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <input
                      type="text"
                      className="form-control"
                      value={arName}
                      onChange={(e) => setArName(e.target.value)}
                      placeholder="Arabic Name"
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <input
                      type="text"
                      className="form-control"
                      value={enName}
                      onChange={(e) => setEnName(e.target.value)}
                      placeholder="English Name"
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <input type="file" onChange={(e) => setImage(e.target.files[0])} />
                  </div>
                  <button type="submit" className="btn btn-primary">
                    Add
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Slider Image Management Modal */}
      {showSliderModal && (
        <div className="modal show d-block bg-dark" tabIndex="-1">
          <div className="modal-dialog modal-lg" style={{ maxWidth: '750px' }}>
            <div className="modal-content " style={{ backgroundColor: '#5C0E11' }}>
              <div className="modal-header">
                <h5 className="modal-title">Manage Slider Images</h5>
                <button type="button" className="btn-close" onClick={() => setShowSliderModal(false)}></button>
              </div>
              <div className="modal-body">
                {isLoading && <p>Loading...</p>}
                {error && <p className="text-danger">{error}</p>}
                {sliderImages.length > 0 ? (
                  <div className="d-flex flex-wrap justify-content-space-around">
                    {sliderImages.map((image) => (
                      <div key={image.id} className="d-flex align-items-center mb-2 ju">
                        <img
                          src={image.link}
                          alt="Slider"
                          style={{ width: '100%', maxHeight: '150px', objectFit: 'contain' }}
                        />
                        <button
                          className="btn  btn-sm"
                          style={{ backgroundColor: '#5C0E11', color: 'white' }}
                          onClick={() => handleDeleteSliderImage(image.id)}
                          disabled={isLoading}
                        >
                          Delete
                        </button>
                      </div>
                    ))}
                  </div>
                ) : (
                  !isLoading && <p>No slider images available.</p>
                )}
                <hr />
                <div className="mt-3">
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => setSelectedFile(e.target.files[0])}
                    disabled={isLoading}
                  />
                  {selectedFile && (
                    <p className="mt-2 text-success">
                      Selected: {selectedFile.name}
                    </p>
                  )}
                  <button
                    className="btn btn-light mt-2"
                    onClick={handleAddSliderImage}
                    disabled={!selectedFile || isLoading}
                  >
                    Add Image
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Sidebar;